import React from 'react'
import styled from 'styled-components'

const Circle = styled.span`
    background-color: ${(p) => p.theme.colors.primaryRed};
    border-radius: 20px;

    width: 8px;
    height: 8px;
    flex-shrink: 0;
    margin-top: -2px;
`

export const RedCircle: React.FC = () => {
    return <Circle />
}
